function setBannerCookieAnim() {
  const banner = document.querySelector(".cookie-banner");
  const duration = 0.6;

  if (!banner) {
    return {
      showBanner: () => {},
      hideBanner: () => {},
    };
  }

  function showBanner() {
    gsap.to(banner, {
      y: 0,
      duration: duration,
      ease: "back.out(0.5)",
    });
  }

  function hideBanner() {
    gsap.to(banner, {
      y: "100%",
      duration: duration,
      ease: "back.out(4)",
    });
  }

  return { showBanner, hideBanner };
}

export default setBannerCookieAnim;
